import _ from 'lodash';
import axios from 'axios';

import router from '@/router';
import pinia from '@/pinia';
import { useAuthStore, useSetupStore } from '@/stores';
import initialize from '@/init'; // fetch setup / initialize the state

router.beforeEach((to, from, next) => {
    const check = () => {
        const authStore = useAuthStore(pinia);
        const setupStore = useSetupStore(pinia);

        // Signed out there is nothing to check against, and deciding on an
        // empty rights list sent every deep link (a ticket URL from a
        // notification mail) to the dashboard before the sign-in form could
        // remember where the person was going. Auth.vue shows the form over
        // whatever route this is and stores its path; SignIn comes back to
        // it once the login has landed, through this guard again with the
        // real rights.
        if (!authStore.token) {
            next();
            return;
        }

        const permissions = _.get(to.meta, 'restrictions.permissions') || [];
        const extensions = _.get(to.meta, 'restrictions.extensions') || [];
        const restrictedActiveExtensions = _.get(to.meta, 'restrictions.activeExtensions') || [];

        let allow = true;
        if (permissions.length || extensions.length || restrictedActiveExtensions.length) {
            // check if current route should be accessed only by specific permissions
            // and redirect if corresponding permission is not present
            // ---
            // if there are restrictions by permissions,
            // then all access permissions must be present

            let allowByPermission = true;
            if (permissions.length) {
                const rights = authStore.rights;
                const superuser = authStore.isSuperUser;
                const owner = authStore.isOwner;

                permissions.forEach(key => {
                    let permitted;
                    switch (key) {
                        case 'superuser':
                            if (!superuser) allowByPermission = false;
                            break;

                        default:
                            if (!superuser && !owner) {
                                let keys = key.split('||');
                                if (keys.length > 1) {
                                    permitted = false;
                                    keys.forEach(key => {
                                        if (permitted === true) return
                                        permitted = !! rights.find(right => right.key === key && right.permission.access)
                                    })
                                } else {
                                    permitted = !! rights.find(right => right.key === key && right.permission.access)
                                }

                                if (!permitted) allowByPermission = false;
                            }
                            break;
                    }
                });
            }

            // check if current route belongs to an extension
            // and redirect if none of its extensions is enabled
            // ---
            // `extensions` are checked against the template-filtered
            // enabledExtensions, `activeExtensions` against the CMS's ACTIVE
            // extensions: system-wide ones (ai-image-edit, ai-content, …) are
            // never template-listed. One match in either list is enough, so a
            // screen two features share (the knowledge base: chatbot or
            // ai-content) opens with either.

            let allowByExtension = true;
            if (extensions.length || restrictedActiveExtensions.length) {
                allowByExtension = extensions.some(extension => setupStore.enabledExtensions.includes(extension))
                    || restrictedActiveExtensions.some(extension => setupStore.activeExtensions.includes(extension));
            }

            // both, allowByPermission and allowByExtension must be true

            allow = allowByPermission && allowByExtension;
        }

        if (allow) {
            document.title = to.meta.title ? to.meta.title : document.title;
            next();
        } else {
            next(from || '/');
        }
    };

    const setupStore = useSetupStore(pinia);
    if (!setupStore.loaded) {
        initialize()
            .then(check)
            .catch(err => {
                // store.dispatch('auth/signout');
                throw err;
            });
    } else {
        check();
    }
});

router.afterEach(() => {
    const setupStore = useSetupStore(pinia);
    setupStore.updateReadyState(true);
    setTimeout(() => {
        setupStore.updateAnimation(null);
    }, 1000);
});

axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        const status = _.get(error, 'response.status');
        const message = _.get(error, 'response.data.message');

        if (status === 503) {
            const setupStore = useSetupStore(pinia);
            setupStore.updateMaintenanceState(message || true);
        }

        return Promise.reject(error);
    }
);
